import React from 'react'
import { Panel } from '../common/Layout'
import PanelHeader from '../common/PanelHeader'
import { useMyReferralWithEnabledDetails } from '../../hooks/referral'
import { CopyReferral } from '../community/Referral'

export const PanelReferral = () => {
  const { referralAndEnabledDetails } = useMyReferralWithEnabledDetails()
  const referralReward =
    referralAndEnabledDetails?.referralEnabledDetails?.rewardAmountPennies / 100
  return (
    <Panel>
      <PanelHeader title="Refer" />
      <CopyReferral referralAndEnabledDetails={referralAndEnabledDetails} />
      <p className="invite-friends-card-subhead">
        {`Invite your friends to Foodsby and you’ll both get a $${referralReward} credit when
            they place their first order and it's delivered.`}
      </p>
    </Panel>
  )
}

export default PanelReferral
